<form [formGroup]='setPasswordForm'>
  <div class="section-block white-background border-round-xl">
    <div class="w-full p-formgrid grid">
      <!-- Transport mode -->
      <div class="col-12 sm:col-12 md:col-12 lg:col-12 xl:col-12" style="padding:0px 0px 0px 15px; margin-bottom: 10px;">
        <span translate class="text-base text-gray-900">Create a password for the {{type}}'s account to enable secure login.</span>

      </div>
      <div class=" col-12 sm:col-12 md:col-12 lg:col-12 xl:col-12">
        <div class="grid">
          <div class="form-field col-12" style="padding:0px 0px 0px 15px">
            <div class="form-label">
              <label for="newPassword" translate>label_new_password<span class="asterisk">*</span></label>
            </div>
            <div class="form-control">

              <p-password formControlName="newPassword" [toggleMask]="true" [feedback]="false"></p-password>

              <div class="form-errors"
                *ngIf="setPasswordForm.controls.newPassword.errors && (setPasswordForm.controls.newPassword.dirty || setPasswordForm.controls.newPassword.touched)">
                <div [hidden]="!setPasswordForm.controls.newPassword.errors.required" translate class="text-sm">
                  error_new_password_required
                </div>
                <div
                  [hidden]="!setPasswordForm.controls.newPassword.errors.minlength && !setPasswordForm.controls.newPassword.errors.pattern"
                  translate class="text-sm">
                  error_password_validation
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class=" col-12 sm:col-12 md:col-12 lg:col-12 xl:col-12">
        <div class="grid">
          <div class="form-field col-12" style="padding:0px 0px 0px 15px">
            <div class="form-label">
              <label for="newConfirmPassword" translate>label_new_confirm_password<span
                  class="asterisk">*</span></label>
            </div>
            <div class="form-control">

              <p-password formControlName="newConfirmPassword" [toggleMask]="true" [feedback]="false"></p-password>

              <div class="form-errors"
                *ngIf="(setPasswordForm.controls.newConfirmPassword.errors && (setPasswordForm.controls.newConfirmPassword.dirty || setPasswordForm.controls.newConfirmPassword.touched)) || showPasswordMismatchError()">
                <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.required" class="text-sm" translate >
                  error_new_confirm_password_required
                </div>
                <div
                  [hidden]="!setPasswordForm.controls.newConfirmPassword.errors.minlength && !setPasswordForm.controls.newConfirmPassword.errors.pattern"
                  translate class="text-sm">
                  error_password_validation
                </div>
                <div *ngIf="showPasswordMismatchError()" translate class="text-sm">
                  error_new_confirm_password_not_match
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
        <div class="col-12 sm:col-12 md:col-12 lg:col-12 xl:col-12" [hidden]='!changePasswordErrors[0]["general"]'>
        <div class="form-errors alert alert-danger" >
          <div *ngFor="let ErrorMessage of changePasswordErrors['general']">
            {{ErrorMessage.message}}
          </div>
        </div>

      </div>
  <div class="col-12">
    <div class="update-password-actions flex justify-content-end gap-2">
      <button
        id="update-password-cancel-btn"
        class="update-password-cancel-btn"
        pButton
        appRipple
        type="button"
        [label]="'Cancel'"
        (click)="onCancel()"></button>
      <button
        id="update-password-save-btn"
        pButton
        appRipple
        class="update-password-save-btn"
        type="button"
        [label]="'Set Password'"
        [disabled]="!setPasswordForm.valid || showPasswordMismatchError()"
        (click)="doChangePassword()"></button>
    </div>
  </div>
</form>